import { h } from 'preact';

import { $lang } from '../../plugins/helper';

const HidePTResult = (props) => {
    return (
        <div className="et-container et-px-4 et-py-5 et-mx-auto">
        <div className="et-flex et-justify-center">
            <div className="neo-card et-rounded">
                <div className="neo-card-body">
                    <h2 className="et-text et-text-center et-text-gray-700 et-font-bold" style="white-space: pre-line">
                        {
                            $lang('pt.result.hide') || "Thank you for taking the Assessment Test. \n\n Please contact your administrator for the results."
                        }
                    </h2>
                </div>
            </div>
        </div>
        </div>
    )
}
export default HidePTResult;